<template>
    <b-container fluid class="footer mt-5">
        <b-row>
            <b-col>
                <b-container>
                    <b-row class="my-3">
                        <b-col md="3" class="py-2">
                            <b-row>
                                <b-col>
                                    <a href="/">
                                        <img class="mr-5" src="@shared/_assets/img/logo.png"/>
                                    </a>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-col>
                                    <div class="d-block" style="font-size:24px;">
                                        <span class="icon-phone">06093-9727-0</span>
                                    </div>
                                    <div class="d-block">Monday - Friday 9.00 - 18.00 o’clock</div>
                                    <div class="d-block mt-3">Fax 06093-9727-97
                                        <br/>
                                        Mail info@pb-acc.de
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="3" class="py-2">
                            <h5>Company</h5>
                            <b-nav vertical>
                                <b-nav-item :key="route.id" :to="route.path.value" v-for="(route) in navItems">
                                    {{ route.label.value }}
                                </b-nav-item>
                            </b-nav>
                        </b-col>
                        <b-col md="3" class="py-2">
                            <h5>Shop</h5>
                            <b-nav vertical>
                                <b-nav-item v-bind:key="category.id"
                                            :to="{ name: 'category', params: { id : category.id }}"
                                            v-for="(category) in filteredCategories">
                                    {{ category.webName }}
                                </b-nav-item>
                            </b-nav>
                        </b-col>
                        <b-col md="3" class="py-2">
                            <h5>Information</h5>
                            <b-nav vertical>
                                <b-nav-item v-bind:key="index" :to="footerItem.path.value"
                                            v-for="(footerItem, index) in footerItems">
                                    {{ footerItem.label.value }}
                                </b-nav-item>
                            </b-nav>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>

    </b-container>
</template>


<script>
    import {mapState} from "vuex";

    export default {
        name: 'footer-component',
        computed: {
            ...mapState('categoryManagement', ['categories']),
            ...mapState('shopContent', ['navItems', 'footerItems']),
            filteredCategories: function () {
                return this.categories.filter(category => category.webName);
            },
        },
    }
</script>
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .footer {
        background-color: #F1F1F1;
        font-size: 13px;
        letter-spacing: 0.5px;
        line-height: 22px;
        background-clip: content-box;

        .nav a {
            font-weight: 300;
            font-size: 13px;
            line-height: 22px;
            padding: 2px 0;

            &:hover {
                font-weight: 500;
            }
        }
    }
</style>
